// @flow

import * as React from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';

import Badge from 'app/components/shared/Badge';

import { formatNumber } from 'app/lib/number';

type TabButtonProps = {
  badge: boolean,
  children: React.Node,
  monochrome?: boolean,
  compact?: boolean
};

const TabButton = (props: TabButtonProps) => (
  <Link
    className={classNames("btn btn-tab", {
      "btn-tab--monochrome": props.monochrome,
      "btn-tab--badged": props.badge,
      "btn-tab--compact": props.compact
    })}
    activeClassName="btn-tab--active"
    {...props}
  />
);

type Props = {
  badge?: number,
  children: React.Node,
  monochrome?: boolean,
  compact?: boolean
};

class Tab extends React.PureComponent<Props> {
  render() {
    const { badge, children, monochrome, compact, ...props } = this.props;

    const affix = badge
      ? <Badge outline={true}>{formatNumber(badge)}</Badge>
      : null;

    return (
      <li>
        <TabButton
          monochrome={monochrome}
          badge={!!badge}
          compact={compact}
          {...props}
        >
          {children}
          {' '}
          {affix}
        </TabButton>
      </li>
    );
  }
}

export default Tab;
